import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from 'services/master/auth';
import { useAuth } from 'contexts/auth';
import { useApp } from 'contexts/app';

const authService = new AuthService();

const useComponent = () => {
  const { showLoading } = useApp();
  const [loginError, setLoginError] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    localStorage.removeItem('workSpace');
  }, []);

  const onFinish = async (values = {}) => {
    setLoginError(null);
    showLoading(true);
    try {
      const user = await authService.userLogin(values || {});
      if (user) {
        login(user);
        return;
      }
      setLoginError({ message: 'Incorrect username or password' });
    } finally {
      showLoading(false);
    }
  };

  const goToResetPassword = () => {
    navigate('/reset-password');
  };

  return {
    loginError,
    onFinish,
    goToResetPassword,
  };
};

export default useComponent;
